import React, { useEffect, useState } from "react";
import LeftPart from "./LeftPart";
import WhatsAppSideBar from "../managePageSidebar/WhatsAppSideBar";
import Title from "components/common/atoms/Title";
import { t } from "components/CentralDataMangement/translation/Translation";
import type {
  OverviewDataProps,
  WhatsAppDataProps,
} from "../annotations/WhatsAppAnnotations";
import { FetchWhatsAppContacts } from "../services/FetchWhatsAppContacts";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import secureLocalStorage from "react-secure-storage";
import { useSelector } from "react-redux";
import { selectAuth } from "features/auth/AuthSlice";
import * as CONST from "../../../../Constants";


const WhatsappOverview = () => {
    const authUser = useSelector(selectAuth);
  
  const [selectedUser, setSelectedUser] = useState<WhatsAppDataProps>({
    to: "",
    personId: null,
    name: "",
    unreadcount: 0,
    lastmessagetime: null,
    profilePicPath: ''
  });

  const [overviewData, setOverviewData] = useState<OverviewDataProps>({
    users: [],
    offices: [],
  });

  const [filterText, setFilterText] = useState({
    office:
      authUser?.role === CONST.RECRUITER ||
      authUser?.role === CONST.OFFICE_MANAGER
        ? [authUser?.officeId, authUser?.correspondingOffice?.id]
        : [],
    name: "",
  });

  const [debouncedFilterText, setDebouncedFilterText] = useState(filterText);

  const handleInputFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterText((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectFilterChange = (selectedOption: any, fieldName: string) => {
    setFilterText((prevData) => ({
      ...prevData,
      [fieldName]: selectedOption,
    }));
  };

  const handleClearFilter = () => {
    setFilterText({
      office: [],
      name: "",
    });
  };

  const handleSelectedUser = (user: WhatsAppDataProps) => {
    setSelectedUser(user);
    setOverviewData((prev) => ({
      ...prev,
      users: prev.users.map((u) =>
        u.personId === user.personId ? { ...u, unreadcount: 0 } : u
      ),
    }));
  };

  // Debounce filterText changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilterText(filterText);
    }, 1000); // debounce delay

    return () => clearTimeout(handler);
  }, [filterText]);

  // Load chats on initial mount or when debounced filter text changes
  useEffect(() => {
    const loadChats = async () => {
      const response = await FetchWhatsAppContacts(debouncedFilterText);
      if (response.status === 200) {
        const data = response.data;
        setOverviewData(data);
      }
    };

    loadChats(); // initial + debounced call

    const interval = setInterval(() => {
      const flag = secureLocalStorage.getItem("whatsappListener");
      if (flag === true) {
        secureLocalStorage.setItem("whatsappListener", false);
        loadChats(); // re-fetch on flag
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [debouncedFilterText]);

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Whatsapp",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <Title title={t("Whatsapp")} />
      <div className="row" style={{ paddingTop: "0.5vw" }}>
        <div className="col-3">
          <LeftPart
            data={overviewData}
            onSelectUser={handleSelectedUser}
            selectedUser={selectedUser}
            filterText={filterText}
            onSelectFilterChange={handleSelectFilterChange}
            onInputFilterChange={handleInputFilterChange}
            onClearFilter={handleClearFilter}
          />
        </div>
        <div className="col-9 whatsappRIghtSidebar">
          <div className="position-relative whatsapp-overview-right-part h-100">
            <WhatsAppSideBar whatsAppData={selectedUser} />
          </div>
        </div>
      </div>
    </AccessControl>
  );
};

export default WhatsappOverview;
